import type { Team } from '@/entities/team';
import request from '@/shared/api/request';

export const createTeam = (data: { name: string; color?: string }): Promise<{ team: Team }> =>
  request({
    url: '/teams/',
    method: 'POST',
    data,
  });
